import { State, Action } from "./types";
import { calcSitePortfolio } from "./utils";
import { getTimeFrameCompareRanges } from "../../../components/Reports/Comfort/utils";

export function reducer(state: State, action: Action) {
  const actionType = action.type;

  switch (action.type) {
    case "LOAD_PORTFOLIO":
      return {
        ...state,
        portfolioLoading: true,
        activeSitesHash: action.activeSitesHash,
      };
    case "LOAD_PORTFOLIO_SUCCESS":
      return {
        ...state,
        portfolioLoaded: true,
        portfolioLoading: false,
        portfolioError: false,
        portfolio: calcSitePortfolio(action.data.sites),
      };
    case "LOAD_PORTFOLIO_FAIL":
      return {
        ...state,
        portfolioLoading: false,
        portfolioError: true,
      };
    case "LOAD_ZONES":
      return {
        ...state,
        zonesLoading: true,
      };
    case "LOAD_ZONES_SUCCESS":
      return {
        ...state,
        zonesLoaded: true,
        zonesLoading: false,
        zonesError: false,
        zones: action.data,
      };
    case "LOAD_ZONES_FAIL":
      return {
        ...state,
        zonesLoading: false,
        zonesError: true,
      };
    case "RESET_ZONES":
      return {
        ...state,
        zones: undefined,
        zonesLoading: false,
        zonesLoaded: false,
      };
    case "SET_VIEW_BY":
      return {
        ...state,
        viewBy: action.viewBy,
      };
    case "SET_RANK_DIR":
      return {
        ...state,
        rankDir: action.rankDir,
      };
    case "SET_TIME_FRAME": {
      const { current, compare } = getTimeFrameCompareRanges(
        action.timeFrameOption,
        action.compareToOption
      );

      return {
        ...state,
        timeFrameOption: action.timeFrameOption,
        compareToOption: action.compareToOption,
        current,
        compare,
      };
    }
    default:
      throw new Error(`Unhandled action type: ${actionType}`);
  }
}
